/**
 * @file: This file holds the drop zone of the upload.
 *
 * The drop zone owns the upload and the question about a file that already
 * exists. It does not draw the question. A dialog under a hidden element is in
 * the top layer without being drawn, and the panel of the library hides its
 * body when the operator collapses it. The panel therefore draws the question,
 * and this component hands the panel the controller that holds the answer.
 */

import './asset-upload.component.less'
import controller from './asset-upload-drop-zone.controller'

export default {
  template: require('./asset-upload-drop-zone.component.html').default,
  controller,
  bindings: {
    onReady: '&'
  }
}
